export default __webpack_public_path__ + "static/media/btn_down_arrow.9777bfd6.svg";